import { render } from "./StepEmail.vue?vue&type=template&id=2fbc940f"
import script from "./StepEmail.vue?vue&type=script&lang=js"
export * from "./StepEmail.vue?vue&type=script&lang=js"

import exportComponent from "/builds/proximis/page_abonnement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__